import { useQueryClient } from '@tanstack/react-query';
import { NextSeo } from 'next-seo';
import Signin from '../src/views/auth/Signin';
import type { NextPageWithAuth } from '../src/types/page';
import { DefaultSEO } from '../src/lib/seo';
import { useRunOnce } from '@fabric-app/hooks/useRunOnce';
import { getDatabase } from '@fabric-app/compat';

const SigninPage: NextPageWithAuth = () => {
  const queryClient = useQueryClient();

  /**
   * for any reason the user lands on signin, we clear the react-query cache
   * (could be in app redirect, user action)
   */
  useRunOnce(() => {
    queryClient.clear();
    getDatabase()?.clear('persistedQueries');
  });

  return (
    <>
      <NextSeo {...DefaultSEO} />
      <Signin />
    </>
  );
};

SigninPage.authRequirements = { requiresAuth: false };

export default SigninPage;
